<template>
  <div class="app-container-v2 table-container-v2">
    <div class="title-box">
      <div class="title-left">
        <span class="title-text">{{ $t('menu.policyLink') }}</span>
      </div>
      <div class="title-right">
        <div class="select-v2 mr16">
          <el-select class="select-round" v-model="queryParams.scope" :placeholder="$t('scopeOfApplication')" filterable clearable @change="handleSearch" default-first-option>
            <i class="el-icon-search color-primary font-16 ml5" slot="prefix"></i>
            <el-option v-for="item in setIdByItemList" :key="item.codeItemId" :value="item.codeItemId + ''" :label="item.codeItemName" />
          </el-select>
        </div>
        <el-button type="primary" class="button-v2" @click="handleAdd">+ {{ $t('handleCreate') }}</el-button>
      </div>
    </div>
    
    <div class="table-body flex vertical" v-loading="loading">
      <air-table
        ref="airTable"
        class="table-v2"
        :show-checkbox="false"
        align="center"
        :columns="columns"
        :data="tableData"
      >
        <template #operation="{ row }">
          <div class="flex center mt4">
            <span class="text-button" @click="handleEdit(row)">{{ $t('handleEdit') }}</span>
            <div class="divider ml10 mr10"></div>
            <span class="text-button" @click="handleDelete(row)">{{ $t('handleDelete') }}</span>
          </div>
        </template>
      </air-table>
      <bsp-pagination :pager-config.sync="pagerConfig" @page-change="pageChange"></bsp-pagination>
    </div>
  
    <el-dialog class="modal-v2" :title="modal.title" :visible.sync="modal.show" :close-on-click-modal="false" width="700px" append-to-body @closed="reset" v-dialog-drag>
      <div class="flex vertical">
        <el-form ref="form" class="form-v2 report-form" :model="form" :rules="formRules" :label-width="lang == 'en' ? '160px' : '100px'" style="margin: 40px 0; padding: 0 30px;" size="small">
          <el-form-item class="fixed-height" :label="$t('scopeOfApplication')" prop="scope">
            <bsp-dicts-select v-model="form.scope" :select-value="form.scope" filterable clearable :optionsList="setIdByItemList" :placeholder="$t('pleaseSelect')"></bsp-dicts-select>
          </el-form-item>
          <el-form-item class="fixed-height" :label="$t('policyType')" prop="policyType">
            <bsp-dicts-select v-model="form.policyType" :select-value="form.policyType" dic-num="9301" filterable clearable :placeholder="$t('pleaseSelect')"></bsp-dicts-select>
          </el-form-item>
          <el-form-item :label="$t('policyName')" prop="policyName">
            <el-input type="textarea" class="textarea-v2" v-model="form.policyName" :placeholder="$t('inputPlaceholder')" maxlength="2000" />
          </el-form-item>
          <el-form-item :label="$t('policyLink')" prop="policyLink" required>
            <el-input type="textarea" class="textarea-v2" v-model="form.policyLink" :placeholder="$t('inputPlaceholder')" maxlength="2000" />
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="w100 flex jbetween acenter">
        <el-button plain class="button-v2" @click="modal.show = false">{{ $t('cancel') }}</el-button>
        <el-button type="primary" class="button-v2" :loading="submitLoading" @click="handleSave">{{ $t('save') }}</el-button>
      </div>
    </el-dialog>
    
    <air-confirm-v2
      :show.sync="confirmShow"
      :title="confirmTitle"
      :content="confirmContent"
      :confirm-function="confirmFunction"
    ></air-confirm-v2>
  </div>
</template>

<script>
  import BspDictsSelect from "@/components/bsp/bsp-dicts-select/bsp-dicts-select";
  import * as api from '@/api/policy/policyLibraryManagement';
  import * as apiA from '@/api/policy/policyLibrary';
  import { validatenull, validateURL } from "@/util/validate";
  import { mapGetters } from 'vuex';
  
  export default {
    name: 'PolicyLink',
    components: {
      BspDictsSelect
    },
    data() {
      const validatePolicyLink = (rule, value, callback) => {
        if (!value) {
          callback(new Error(this.$t('inputPlaceholder')));
        } else if (!validateURL(value)) {
          callback(new Error(this.$t('correctLinkTip')));
        }else {
          callback();
        }
      };
      return {
        setIdByItemList: [],
        loading: true,
        pagerConfig: {
          page: 1,
          limit: 20,
          total: 0
        },
        queryParams: {
          scope: ''
        },
        columns: [
          {title: this.$t('scopeOfApplication'), field: 'scopeText', minWidth: 100},
          {title: this.$t('policyType'), field: 'policyTypeText', minWidth: 120},
          {title: this.$t('policyName'), field: 'policyName', minWidth: 200},
          {title: this.$t('policyLink'), field: 'policyLink', minWidth: 200}
        ],
        dictMap: {},
        tableData: [],
        form: {},
        formRules: {
          scope: [{ required: true, message: this.$t('pleaseSelect'), trigger: 'change' }],
          policyType: [{ required: true, message: this.$t('pleaseSelect'), trigger: 'change' }],
          policyName: [{ required: true, message: this.$t('inputPlaceholder'), trigger: 'blur' }],
          policyLink: [{ validator: validatePolicyLink, trigger: 'blur' }],
        },
        fileList: [],
        modal: {
          show: false,
          title: this.$t('createLink'),
          edit: false
        },
        submitLoading: false,
        confirmShow: false,
        confirmTitle: '',
        confirmContent: '',
        confirmFunction: undefined
      }
    },
    computed: {
      ...mapGetters(['dicts', 'lang'])
    },
    created() {
      this.init();
    },
    methods: {
      resetForm(formName) {
        if (this.$refs[formName] !== undefined) {
          this.$refs[formName].resetFields();
        }
      },
      init() {
        this.getSetIdByItemList()
          .then(() => {
            this.getData();
          })
          .catch(error => {
            this.loading = false;
          })
      },
      // 获取适用范围
      getSetIdByItemList() {
       return new Promise((resolve, reject) => {
         let params = {
           setList: 1036
         }
         apiA.setIdByItemList(params)
           .then(res => {
             this.setIdByItemList = res.data.data;
             resolve(true);
           })
           .catch(error =>{
             reject(error);
             this.setIdByItemList = [];
           })
       })
      },
      pageChange({ type, currentPage, pageSize }) {
        if (type == 'size') {
          this.pagerConfig.page = 1;
        }
        this.getData();
      },
      getData() {
        this.loading = true
        const { page, limit } = this.pagerConfig;
        let params = {
          pageNum: page,
          pageSize: limit,
          ...this.queryParams
        }
        api.linkList(params)
          .then(res => {
            if (!this.dictMap.scope) {
              this.dictMap.scope = this.$arrayToObj(this.setIdByItemList, 'codeItemId');
              this.dictMap.policyType = this.$arrayToObj(this.dicts.codeList['9301'], 'codeItemId');
            }
            this.tableData = this.$handleTableDict(res.data.data.list, this.dictMap);
            this.pagerConfig.total = res.data.data.total;
            this.loading = false;
          })
          .catch(error => {
            this.loading = false;
          })
      },
      // 搜索
      handleSearch() {
        this.pagerConfig.page = 1;
        this.getData();
      },
      reset() {
        this.form = {};
        this.modal.edit = false;
        this.resetForm('form');
      },
      handleAdd() {
        this.modal.title = this.$t('createLink');
        this.$nextTick(() => {
          this.modal.show = true
        })
      },
      handleSave() {
        this.$refs.form.validate(valid => {
          if (valid) {
            delete this.form.scopeText;
            delete this.form.policyTypeText;
            this.submitLoading = true;
            const fn = this.modal.edit ? api.linkUpdate : api.linkAdd;
            fn(this.form).then(res => {
              if (res.data.code === 0) {
                this.getData();
                this.modal.show = false
              }
            }).finally(() => this.submitLoading = false)
          }
        })
      },
      // 编辑
      handleEdit(row) {
        this.form = {
          ...row
        }
        this.modal.title = this.$t('editLink');
        this.modal.edit = true;
        this.modal.show = true;
      },
      // 删除
      handleDelete(item) {
        this.confirmShow = true
        this.confirmTitle = this.$t('deleteLink');
        this.confirmContent = `${ this.$t('sureDeleteLink') }「${item.policyName}」?`;
        this.confirmFunction = () => {
          api.linkDel({ id: item.id }).then(() => {
            this.getData()
            this.$msgSuccess(this.$t('deleteSuccessfully'))
          })
        }
      }
    }
  }
</script>
<style lang="scss" scoped>
  @import "~@/air/assets/css/main.scss";
</style>
